export default {
  Module: '模块',
  Function: '功能',
  ExecutionObject: '执行对象',
  OperatTime: '操作时间',
  ChangeUser: '修改人',
  ModifyRole: '修改角色',
  SearchPlaceholder: '搜索用户账号/操作描述',
  Result: '结果',
  OperationDescription: '操作描述',
}